import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer>
      {/* Top Navigation Bar */}
      <div className="footer-top-nav">
        <Link onClick={toTop} to="/about">
          <span className="icon">👤</span> Our Story
        </Link>
        <Link onClick={toTop} to="/shop">
          <span className="icon">📦</span> Best Sellers
        </Link>
        <Link onClick={toTop} to="/contact">
          <span className="icon">⊕</span> Get Support
        </Link>
        <Link onClick={toTop} to="/shop">
          <span className="icon">📡</span> Latest Arrivals
        </Link>
      </div>

      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="footer-container">
          {/* Left Section - Logo and Subscribe */}
          <div className="footer-left">
            <div className="footer-logo">
              <div className="logo-circle">S</div>
              <div className="logo-text">
                <span className="brand-name">Sadiemall</span>
                <span className="brand-tagline">modern apothecary</span>
              </div>
            </div>

            <div className="footer-subscribe">
              <p>find@sadiemall.site</p>
            </div>

            {/* Social Media Icons */}
            <div className="footer-social">
              <Link
                to="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </Link>
              <Link
                to="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-twitter"></i>
              </Link>
              <Link
                to="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </Link>
              <Link
                to="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-pinterest-p"></i>
              </Link>
              <Link
                to="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </Link>
              <Link
                to="https://tiktok.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-tiktok"></i>
              </Link>
            </div>
          </div>

          {/* Right Section - Links */}
          <div className="footer-right">
            {/* About Us Column */}
            <div className="footer-column">
              <h4>ABOUT US</h4>
              <div className="footer-links">
                <Link onClick={toTop} to="/about">
                  Our Story
                </Link>
              </div>
            </div>

            {/* Customer Service Column */}
            <div className="footer-column">
              <h4>CUSTOMER SERVICE</h4>
              <div className="footer-links">
                <Link onClick={toTop} to="/contact">
                  Contact Us
                </Link>
                <Link onClick={toTop} to="/shipping">
                  Shipping
                </Link>
                <Link onClick={toTop} to="/returns">
                  Return and Refund Policy
                </Link>
              </div>
            </div>

            {/* Legal Column */}
            <div className="footer-column">
              <h4>LEGAL</h4>
              <div className="footer-links">
                <Link onClick={toTop} to="/terms">
                  Terms of Service
                </Link>
                <Link onClick={toTop} to="/privacy">
                  Privacy Policy
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright">
          © 2025, Sadiemall All Rights Reserved.
        </div>
      </div>
    </footer>
  );
}

export default Footer;
